var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header",class:[
        _vm.isFixed || _vm.isDark ? 'header-dark' : ''
    ],style:(_vm.headerStyle)},[_c('div',{staticClass:"header-container"},[_c('div',{staticClass:"logo",style:(_vm.logoStyle),on:{"click":function($event){_vm.log({
                type: 'CLICK',
                event_name: 'TOP_TAB_BUTTON',
                event_value: {
                    icon: '快手log'
                }
            });_vm.backHome()}}}),(_vm.isFixed || _vm.isDark)?_c('EasyNav',{attrs:{"is-dark":_vm.isFixed || _vm.isDark,"can-send-show-log":_vm.canSendShowLog,"nav-ui-data":_vm.easyNavUIData,"sub-list-ui-data":_vm.subListUIData}}):_vm._e(),_c('Search',{class:[
                _vm.isFixed || _vm.isDark ? '' : 'header-search'
            ],attrs:{"search-ui-data":_vm.searchUIData},on:{"search":function($event){return _vm.log({
                type: 'CLICK',
                event_name: 'TOP_TAB_BUTTON',
                event_value: {
                    icon: '搜索框按钮'
                }
            })}}}),_c('NavToolBar',{attrs:{"nav-ui-data":_vm.navToolBarUIData,"login-ui-data":_vm.loginStyle}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }